import { parseComment } from './parse-comment'

const formatEditorText = (text, participants) => {
  const today = new Date().getTime()
  const textParsed = parseComment(text, participants)
  const payload = {
    time: today,
    blocks: [
      {
        data: { text: textParsed },
        type: 'paragraph',
      },
    ],
    version: '2.18.0',
  }
  return payload
}

export default formatEditorText
